export default "/images/dcbb7fb71c7787e3ff4e511611c4c58f.avif";